import Header from "../components/tavern/Header";
import Hero from "../components/tavern/Hero";
import SocialProof from "../components/tavern/SocialProof";
import CtaRow from "../components/tavern/CtaRow";
import MenuHighlights from "../components/tavern/MenuHighlights";
import Gallery from "../components/tavern/Gallery";
import LocationHours from "../components/tavern/LocationHours";
import Footer from "../components/tavern/Footer";
import MobileDock from "../components/tavern/MobileDock";

export default function Home() {
  return (
    <main
      data-testid="landing-root"
      className="rustic-grain min-h-screen text-[color:var(--pk-text)]"
    >
      <Header />
      <Hero />
      <SocialProof />
      <CtaRow />
      <MenuHighlights />
      <Gallery />
      <LocationHours />
      <Footer />
      <MobileDock />
    </main>
  );
}
